define('home/utils/confirmModal',[
    'jquery',

    'home/utils/navigationUtils',
    'home/templates/confirmModal',
], function (
    $,

    navigationUtils,
    confirmModalTemplate
) {
    'use strict';

    // modal types enum
    // determines which actions are shown
    var TYPES = {
        'CLOSE': 1,
        'CONFIRM_CANCEL': 2,
        'CLOSE_ICON': 3,
        'CLOSE_LIGHT': 4,
    };

    // Calculate the width of the scrollbar and add css rules that will prevent the page from
    // jumping when modal visibility is toggled
    function getScrollbarWidth() {
        var scrollDiv = $('<div>').addClass('modal-scrollbar-measure')[0];
        $('body').append(scrollDiv);

        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        $(scrollDiv).remove();

        return scrollbarWidth;
    }


    function insertCss(code) {
        var style = $('<style>').attr('type', 'text/css')[0];

        if (style.styleSheet)  // IE
            style.styleSheet.cssText = code;
        else  // Other browsers
            style.innerHTML = code;

        $('head').append(style);
    }

    $(function () {
        var scrollbarWidth = getScrollbarWidth();

        // Modal scroll fix only applies for screens larger than mobile.
        // This is because the body styling that causes content to jump when the modal
        // is opened only applies in desktop.
        var rules = [
            '@media only screen and (min-width: 480px) {',
            'body.scroll-fix { margin-right: ' + scrollbarWidth + 'px; }',
            'body.scroll-fix .compensation { margin-right: ' + scrollbarWidth + 'px; }',
            '}',
        ].join(' ');

        insertCss(rules);
    });

    /**
     * Creates and returns the jquery wrapped modal element, ready to be inserted into
     * the page and shown.
     * Modal has default support for body styling on open and close, and removes itself
     * from the DOM on close.
     *
     * @param  {Object} options - {
     *                              modal.type (optional) - one of the modal types (ex: TYPES.CLOSE),
     *                              handlers (optional) - a mapping from bootstrap modal events to handlers
     *                            }
     *
     * @returns {JQuery} JQuery-wrapped element
     */
    function getModal(options) {
        options = options || {};
        options.modal = options.modal || {};

        var $modal = $(confirmModalTemplate({
            type: options.modal.type || TYPES.CLOSE_ICON,
            types: TYPES,
        }));

        if (options.modal.content)
            $modal.find('[data-role=content]').html(options.modal.content);

        $modal
            .on('shown.bs.modal', function () {
                $('body').addClass('scroll-fix');
            })
            .on('hidden.bs.modal', function () {
                $('body').removeClass('scroll-fix');
                $modal.remove();
            })
            .on('click', 'a[data-action=close-and-navigate]', function (evt) {
                evt.preventDefault();

                var $target = $(evt.target);
                var href = $target.attr('href');
                if (href)
                    navigationUtils.navigate(href, { trigger: true });

                $modal.modal('hide');
            });

        $('body').append($modal);

        return $modal;
    }

    /**
     * Shows a confirmation modal containing the given html, and either a
     * Close button, or a Confirm and Cancel buttons, depending on the
     * specified type.
     *
     * Returns a promise that will resolve once the modal is closed, with
     * a truthy value if confirm was clicked, or a falsy value otherwise.
     *
     * @param  {number} type - One of the enums to specify which set of
     *                         buttons to show
     * @param  {string} content - HTML to fill the confirm modal
     * @returns {Promise} - A promise resolved once the modal is closed with
     *                     a boolean indicator of whether or not confirm was
     *                     selected and a reference to the modal.
     */
    function confirmationPromise(type, content) {
        type = type || TYPES.CLOSE;

        var deferred = $.Deferred();

        var $modal = getModal({
            modal: {
                type: type,
                content: content,
            },
        });

        $modal.on('click', '[data-action=confirm]', function () {
            deferred.resolve(true, $modal);
        })
        .on('hidden.bs.modal', function () {
            deferred.resolve(false, $modal);
        });

        $modal.modal('show');

        return deferred.promise();
    }

    return {
        TYPES: TYPES,
        getModal: getModal,
        confirmationPromise: confirmationPromise,
    };
});

